<template>
    <div>
        <h1>로그인 / 로그아웃</h1>

        <section class="mt-4">
            <example-layout class="overflow-auto mt-8">
                <template v-slot:render>
                    <example-login-logout />
                </template>
            </example-layout>
        </section>
    </div>
</template>

<script>
import exampleLayout from '@/components/developer/example-layout.vue'
import prismEditor from '@/components/developer/prism-editor.vue'

import exampleLoginLogout from '@/components/developer/auth/example-login-logout.vue'

export default {
    components: {
        exampleLayout,
        prismEditor,

        exampleLoginLogout
    },
    
}
</script>